var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-filter',{attrs:{"options":_vm.options,"param":_vm.param,"label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }